import { render, staticRenderFns } from "./UserManageDetailOne.vue?vue&type=template&id=0c887862&"
import script from "./UserManageDetailOne.vue?vue&type=script&lang=js&"
export * from "./UserManageDetailOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports